import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from 'react'
import { motion } from "framer-motion";
import "react-alice-carousel/lib/alice-carousel.css";
import HeroVideo from '../../../assets/images/hero/hero-bg.mp4';
import "./hero.css"
const Hero = () => {
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);


  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const timeoutId = setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
        setIsLoading(true);
      };
    }
  }, []);
  return (
    <section className="homepage__hero">
      <video ref={videoRef} autoPlay loop muted playsInline preload="none" width="375" className={`hero__video ${isLoading ? '' : 'loaded'}`}>
        <source src={HeroVideo} type="video/mp4" />
        Dein Browser unterstützt das Video-Tag nicht.
      </video>


      <section className="hero__info flex-container flex-column txt-center pop-font txt-white">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 3 }}
        >
          <span>Willkommen</span>
          <h1 className="txt-white">Genieße das perfekte Stück</h1>
          <p className="txt-white">
            Deine Lieblingspizza zu bestellen ist schnell und einfach – dank unserer zuverlässigen Partner.
          </p>
        </motion.div>

        <div className="hero__interaction flex-container flex-row">
          <Link className="passive-button-style" to="/blog">
            Blog lesen
          </Link>
          <Link className="passive-button-style  " to="/menu">
            Speisekarte ansehen
          </Link>
        </div>
      </section>

    </section>

  );
}

export default Hero;